import { render, staticRenderFns } from "./InformazioniLegali.vue?vue&type=template&id=2a682ca0&scoped=true&"
import script from "./InformazioniLegali.vue?vue&type=script&lang=js&"
export * from "./InformazioniLegali.vue?vue&type=script&lang=js&"
import style0 from "./InformazioniLegali.vue?vue&type=style&index=0&id=2a682ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a682ca0",
  null
  
)

export default component.exports